import JSEncrypt from "jsencrypt";
import Cookies from "js-cookie";
import { setToken, setSystemRole, getToken } from '@/utils/auth'
import { imgBaseUrl, changeFavicon, getDomainPrefix, bigUrl, priviteKey, publicKey } from '@/utils/common'

const loginMixin = {
    data() {
        let _this = this;
        const validatePassword = (rule, value, callback) => {
            if (value.length < 6) {
                callback(new Error(this.$t('密码不能少于6位数')))
            } else {
                callback()
            }
        }
        return {
            rememberPassword:false,
            loginForm: {
                username:'',
                password:'',
                code:''
            },
            loginRules: {
                username: [
                    { required: true, message: this.$t('用户名不能为空'), trigger: 'blur' },
                    { validator: _this.specialChart, trigger: 'blur' }
                ],
                password: [{ required: true, trigger: 'blur', validator: validatePassword }]
            },
            WxQR:'',
            wxInterval:null
        }
    },
    mounted() {
        /*记住密码*/
        var userLogin = Cookies.get("cookieUserBase2") ? JSON.parse(Cookies.get("cookieUserBase2")) : ''
        if (userLogin) {
            let username = this.decrypt(userLogin.username)
            let password = this.decrypt(userLogin.password)
            this.loginForm = {
                username: username,
                password: password,
                code: ''
            };
            this.rememberPassword = true;
        }
    },
    methods:{
        // 加密
        encrypt(text) {
            const encryptor = new JSEncrypt()
            encryptor.setPublicKey(publicKey) // 设置公钥
            return encryptor.encrypt(text) // 对数据进行加密
        },

        // 解密
        decrypt(text) {
            const decryptor = new JSEncrypt()
            decryptor.setPrivateKey(priviteKey) // 设置私钥
            return decryptor.decrypt(text) // 对数据进行解密
        },
        goBigDataLink(link){
            let domain = window.location.pathname
            let domainPrefix = getDomainPrefix(domain)
            if(link.indexOf('?') > -1) {
                location.href = link+"&token="+getToken()+"&realm="+domainPrefix
            }else{
                location.href = link+"?token="+getToken()+"&realm="+domainPrefix
            }
        },
        handleLogin() {
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    let sendData = JSON.parse(JSON.stringify({
                        username : this.loginForm.username,
                        password: this.loginForm.password
                    }))
                    if(this.pageConfig.showCode && process.env.NODE_ENV === 'production') {
                        sendData.code = this.loginForm.code
                    }

                    //用户名不能为空
                    if(!sendData.username){
                        this.$message({message: this.$t('用户名不能为空'), type: 'warning'})
                        return
                    }

                    this.$httpSys.get("/auth/user/getPublicKey").then(res => {
                        const encrypt = new JSEncrypt()
                        encrypt.setPublicKey(res.data) //设置公钥
                        sendData.username = encrypt.encrypt(encodeURI(sendData.username));
                        sendData.password = encrypt.encrypt(encodeURI(sendData.password));
                        sendData.salt = "rsa"// 加密标识



                        this.$httpSys.post("auth/user/pass/login", sendData).then(data => {
                            let obj = data.data;
                            this.loginSuccess(obj)
                        })
                    })
                }
            })
        },
        loginSuccess(obj) {
            //设置用户信息
            obj.user.projectCurrent = obj.projectCurrent;
            this.$store.commit('SET_USERINFO', obj.user)
            this.$store.commit('SET_SECONDROUTERS', '')//清空设置的二级菜单
            setToken(obj.token)
            this.$store.commit('SET_SYSTEMROLE', obj.systemRole)
            setSystemRole(obj.systemRole)
            //记住密码
            var strUser = {
                username: this.encrypt(this.loginForm.username),
                password: this.encrypt(this.loginForm.password)
            };
            strUser = JSON.stringify(strUser)
            if (this.rememberPassword) {
                Cookies.set("cookieUserBase2", strUser, { expires: 7, path: "/" });
            } else {
                Cookies.set("cookieUserBase2", strUser, { expires: 0, path: "/" });
            }
            //保存企业列表
            if(obj.systemRole) {
                // 查询列表
                let sendObj = {
                    "pageObj": {
                        "current": 1,
                        "size": 1000
                    }
                }
                this.$httpSys.post("/crm/customizeInfo/page",sendObj).then(res => {
                    const domainList = res.data.list.map(item => {
                        return {
                            domainPrefix: item.domainPrefix,
                            customName: item.customName
                        }
                    }).filter(item => item.domainPrefix!=='origin')
                    domainList.unshift({
                        domainPrefix:'',
                        customName: this.$t('默认')
                    })
                    this.$store.commit('SET_DOMAINLIST', domainList)
                    // 判断默认域名
                    let domainPrefix = getDomainPrefix(window.location.pathname)
                    if(domainPrefix) {
                        this.$store.commit('SET_CURRENTDOMAIN', domainPrefix)
                    }else{
                        this.$store.commit('SET_CURRENTDOMAIN','')
                    }
                    this.Jump()
                })
            }else{
                // 直接获取
                const domainList = obj.pageCustomize.map(item => {
                    return {
                        domainPrefix: item.domainPrefix,
                        customName: item.customName
                    }
                })
                if(obj.www) {
                    domainList.unshift({
                        domainPrefix:'',
                        customName: this.$t('默认')
                    })
                }
                this.$store.commit('SET_DOMAINLIST', domainList)
                // 判断默认域名
                let domainPrefix = getDomainPrefix(window.location.pathname)
                if(domainPrefix) {
                    this.$store.commit('SET_CURRENTDOMAIN', domainPrefix)
                }else{
                    const storeCurrentDomain = this.$store.getters.currentDomain
                    if(domainList.findIndex(item => item.domainPrefix === storeCurrentDomain) === -1) {
                        if(domainList.length > 0) {
                            this.$store.commit('SET_CURRENTDOMAIN', domainList[0].domainPrefix)
                        }else{
                            this.$store.commit('SET_CURRENTDOMAIN','')
                        }
                    }
                }
                this.Jump()
            }
        },
        Jump() {
            switch(this.pageConfig.loginJumpMethod) {
                case "1":
                    this.$router.push({ path: '/' })
                    // this.$router.push({ path: '/platform/projectOverview' }) //跳转到项目概况模型页面
                    break;
                case "2":
                    this.goBigDataLink(this.pageConfig.platformLogoPath)
                    break;
                case "3":
                    if(this.pageConfig.loginJumpUrl.indexOf('http') === 0) {
                        window.open(this.pageConfig.loginJumpUrl)
                    }else{
                        this.$router.push({path: this.pageConfig.loginJumpUrl})
                    }
                    break;
            }
        },
        wxLogin() {
            this.changeType('weChatLogin')
            this.$httpSys.post("/auth/userWechat/getGUID").then(res => {
                const UUID = res.data
                this.$httpSys({
                    url:"/auth/userWechat/QRcode/authorize/login/"+UUID,
                    responseType: 'blob'
                }).then(res1 => {
                    this.WxQR = window.URL.createObjectURL(res1)
                    this.wxInterval = setInterval(()=>{
                        this.$httpSys.get("/auth/userWechat/getWxScanData/"+UUID).then(res3=>{
                            if(res3.data){
                                this.clearWxInterval()
                                let obj = res3.data.loginInfo;
                                this.loginSuccess(obj)
                            }
                        })
                    },3000)
                })
            })
        },
        backLogin() {
            this.changeType('loginForm')
            this.clearWxInterval()
        },
        clearWxInterval() {
            if(this.wxInterval){
                clearInterval(this.wxInterval)
                this.wxInterval = null
            }
        }
    }
}

export default loginMixin